import React from 'react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Eye, Download } from 'lucide-react';
import { ParsedLine } from '@/lib/leadsheetParser';
import { LineRenderer } from './LineRenderer';

interface PreviewSectionProps {
  tekstOgAkkorder: string;
  parsedLines: ParsedLine[];
  transpose: number;
  fontSize: string;
  chordFontSize: number;
  chordColor: string;
  onDownloadPDF: () => void;
}

export const PreviewSection: React.FC<PreviewSectionProps> = ({
  tekstOgAkkorder,
  parsedLines,
  transpose,
  fontSize,
  chordFontSize,
  chordColor,
  onDownloadPDF,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label className="flex items-center gap-2 text-base font-semibold">
          <Eye className="h-5 w-5 text-primary" />
          Forhåndsvisning
        </Label>
        <Button 
          variant="outline" 
          size="sm" 
          className="gap-2"
          onClick={onDownloadPDF}
          disabled={!tekstOgAkkorder}
        >
          <Download className="h-4 w-4" />
          Last ned PDF
        </Button>
      </div>
      <div
        className="border rounded-lg bg-white p-6 min-h-[400px] overflow-auto shadow-inner"
        style={{ 
          fontSize: `${fontSize}px`,
          fontFamily: "'Courier New', monospace"
        }}
      >
        {tekstOgAkkorder ? (
          <div className="font-mono">
            {parsedLines.map((line, index) => (
              <LineRenderer
                key={index}
                line={line}
                lineIndex={index}
                parsedLines={parsedLines}
                transpose={transpose}
                fontSize={fontSize}
                chordFontSize={chordFontSize}
                chordColor={chordColor}
              />
            ))}
          </div>
        ) : (
          <div className="text-muted-foreground text-center py-12">
            Ingen tekst/akkorder lagt til ennå
          </div>
        )}
      </div>
    </div>
  );
};

